import { useRef, useEffect } from "react";
import { sources } from "../constants/source-data";

interface UseSourceScrollProps {
  selectedSource: string;
  selectedSubSource?: string;
}

export const useSourceScroll = ({
  selectedSource,
  selectedSubSource,
}: UseSourceScrollProps) => {
  const sourceRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  // 선택된 소스가 변경될 때 해당 소스를 상단으로 스크롤
  // 단, 하위 소스가 선택된 경우에는 스크롤하지 않음 (useSourceFocus가 처리)
  useEffect(() => {
    if (selectedSource && !selectedSubSource) {
      const selectedSourceData = sources.find(
        (s) => s.label === selectedSource
      );
      if (selectedSourceData && sourceRefs.current[selectedSourceData.id]) {
        setTimeout(() => {
          sourceRefs.current[selectedSourceData.id]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }, 100);
      }
    }
  }, [selectedSource, selectedSubSource]);

  const setSourceRef = (sourceId: string, element: HTMLDivElement | null) => {
    sourceRefs.current[sourceId] = element;
  };

  return { setSourceRef };
};
